import {HttpContext, HttpContextToken} from '@angular/common/http';

export const CANCEL_REQUEST = new HttpContextToken<boolean>(() => true);

export function createCancelRequestContext(shouldCancelRequest: boolean): HttpContext {
  return new HttpContext().set(CANCEL_REQUEST, shouldCancelRequest);
}
